// extracted by mini-css-extract-plugin
export default {"body":"About_body__qz17W"};